import { Outlet } from "react-router-dom";
import { useTheme } from "styled-components";

import { ColumnContainer } from "@sso/ui/FlexBox";

export const TableLayoutContent = () => {
  const theme = useTheme();

  return (
    <ColumnContainer
      rounded
      width="100%"
      position="relative"
      height="calc(100vh - 88px)" //88px = header size (56px) + 2rem padding of the container (32px default)
      justify="flex-start"
      align="flex-start"
      padding="0.5rem"
      bgColor={theme.colors.background.paper}
    >
      <Outlet />
    </ColumnContainer>
  );
};
